import {
  RectangleGroupIcon,
  TableCellsIcon,
} from "@heroicons/react/24/outline";
import { SearchInput } from "@/core/components/search-input";
import {
  TimeframeFilter,
  TimeframeValue,
} from "@/core/components/time-frame-filter";
import { Button } from "@/core/components/ui/button";
import { LoadingCount } from "@/core/components/ui/loading-count/loading-count";
import { Separator } from "@/core/components/ui/separator";
import { Stack } from "@/core/components/ui/stack";
import {
  ToggleSwitch,
  ToggleSwitchItem,
} from "@/core/components/ui/toggle-switch";
import { Typography } from "@/core/components/ui/typography";

interface ReferralsHeaderProps {
  referralsCount: number;
  isLoadingReferrals: boolean;
  searchValue: string;
  onSearchChange: (value: string) => void;
  timeframeValue: TimeframeValue;
  onTimeframeChange: (value: TimeframeValue) => void;
  viewType: "kanban" | "table";
  onViewChange: (view: "kanban" | "table") => void;
  onAddAdvocate: () => void;
  onAddReferral: () => void;
  noReferrals: boolean;
}

export const ReferralsHeader = ({
  referralsCount,
  isLoadingReferrals,
  searchValue,
  onSearchChange,
  timeframeValue,
  onTimeframeChange,
  viewType,
  onViewChange,
  onAddAdvocate,
  onAddReferral,
  noReferrals,
}: ReferralsHeaderProps) => (
  <Stack
    direction="row"
    justify="between"
    align="center"
    fullWidth
    className="mx-auto min-w-min max-w-[1680px] px-8 py-4"
  >
    <Typography variant="titleW3" className="inline-flex items-center gap-2">
      Referrals{" "}
      <LoadingCount
        count={referralsCount}
        isCountLoading={isLoadingReferrals}
      />
    </Typography>
    <Stack direction="row" align="center" gap="sm">
      {!noReferrals && (
        <>
          <SearchInput
            placeholder="Search Referrals"
            value={searchValue}
            onChange={onSearchChange}
            data-cy="referrals-search-input"
            className="bg-card"
          />
          <TimeframeFilter
            value={timeframeValue}
            onChange={onTimeframeChange}
          />
          <ToggleSwitch
            value={viewType}
            onValueChange={(value) => onViewChange(value as "kanban" | "table")}
          >
            <ToggleSwitchItem value="kanban">
              <RectangleGroupIcon className="h-5 w-5" />
            </ToggleSwitchItem>
            <ToggleSwitchItem value="table">
              <TableCellsIcon className="h-5 w-5" />
            </ToggleSwitchItem>
          </ToggleSwitch>
          <Separator orientation="vertical" className="mx-2 h-10" />
        </>
      )}
      <Button
        size="sm"
        variant="secondary"
        onClick={onAddAdvocate}
        data-cy="add-advocate-button"
      >
        New Advocate
      </Button>
      <Button size="sm" onClick={onAddReferral} data-cy="add-referral-button">
        New Referral
      </Button>
    </Stack>
  </Stack>
);
